import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson23: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson22"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">
            Meta Trader 5 Guide
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"https://www.unityacademy.io/dashboard"} target="_blank">
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[7.5rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-gainsboro-100 font-dm-sans">

        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>What is MT5?</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            MetaTrader 5 (MT5) is the next generation trading platform from
            MetaQuotes, following on from the hugely popular MetaTrader 4 (MT4).
            While MT4 was optimised for forex trading, MT5 is functionally
            intended to accommodate more asset classes which include
            cryptocurrencies. MT5 is the ideal multi-asset platform for the
            modern trader that seeks to enhance their trading experience using a
            choice of powerful and effective new features as well as highly
            practical trading tools and resources. AvaTrade offers the powerful
            MT5 to its traders, allowing them to trade multiple assets, such as
            CFD’s on forex, stocks, commodities, indices, futures, energies and
            cryptocurrencies, with flexible leverage as well as no re-quotes, no
            price rejections and zero slippages. A core benefit of the
            MetaTrader 5 platform is that you can trade from anywhere, from the
            comfort of your smartphone and tablet. This is via the MT5 Web
            platform, which enables you to trade your assets of choice from any
            web browser and any device. In addition, the MT5 platform offers
            trading robots, trading signals and copy trading. All of these
            powerful features can be used from a single trading platform.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Download and Install</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Here are the minimum system requirements for using MT5 on your PC:
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                Windows 7 Operating System or higher (64-bit system recommended)
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                Pentium 4/Athlon 64 processor or higher (All modern CPUs should
                be able to support this)
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                If you intend to be a heavy user (For instance, opening multiple
                charts and utilising multiple EAs), you could consider more
                powerful hardware options
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Follow the steps below to download and install MT5 on your PC:
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>Click on MetaTrader 5 download link</span>
            </li>
            <li className="mb-[0rem]">
              <span>Run the ava5setup.exe file</span>
            </li>
            <li className="mb-[0rem]">
              <span>Enter your real account login information</span>
            </li>
            <li className="mb-[0rem]">
              <span>
                You can open a new demo account directly from the platform too
              </span>
            </li>
            <li>
              <span>Begin trading</span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <p className="m-0 text-[1.88rem]">
            <b>Place your Order</b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you have already logged into your MT5, it is now time to
                trade your favourite assets.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>There are several ways to place an order on MT5:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Click on Tools on the Menu bar. Then select ‘New Order’
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  On the Market Watch window, double click on the asset you wish
                  to trade (you can also right-click on your desired asset and
                  then select ‘New order’)
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Right-click on the Trade tab on the lower terminal and select
                  ‘New Order’
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Press F9 for one-click trading on the chart of your favourite
                  asset
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                When any of the above options are applied, the ‘Order Screen’
                will pop up. The screen will have a tick chart on its left side
                and customisable order details on the right. The tick chart
                displays the bid and ask prices, and thus, the real-time spreads
                (the difference between the bid and ask prices).
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>The order details on the right are:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Symbol</b>
                <span>
                  {" "}
                  This is the asset you wish to trade, such as the EURUSD
                  currency pair.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Order Type</b>
                <span>
                  {" "}
                  You can choose between Market Execution and Pending Execution
                  order types.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Volume</b>
                <span>
                  {" "}
                  This is the quantity (in lot sizes) that you wish to trade, of
                  the selected underlying asset. On a standard account – 1 lot
                  size is the equivalent of 100,000 units, which typically means
                  that a 1 pip movement will be about 10 US dollars (USD) on
                  most assets.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Stop Loss and Take Profit</b>
                <span>
                  {" "}
                  You will be able to attach Stop Loss and Take Profit orders on
                  all your trades. Stop loss orders help curb your maximum loss
                  when the asset price moves against you, while take profit
                  orders allow you to book profits when the asset price moves in
                  your favour.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <b className="font-dm-sans">Comment</b>
                <span>
                  {" "}
                  You can add any notes regarding a trade in the comment
                  section. This is ideal for traders that document their trading
                  activities.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <p className="m-0 text-[1.88rem]">
            <b>MetaTrader 5 – Order Types</b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                As mentioned above, you can trade your favourite assets using 2
                order types: Market order and Pending order.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  A market order is an order to buy or sell an asset at the
                  current price. The order will be executed in real-time.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  On the other hand, a pending order is an order to buy or sell
                  an asset at a certain price in the future.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The MT5 platform has 6 pending order types as follows:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Buy Stop `}</b>
                <span>
                  An order to buy an asset at a higher price than the current
                  price, in anticipation that when that price is achieved, the
                  trend will continue higher.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Sell Stop</b>
                <span>
                  {" "}
                  An order to sell an asset at a lower price than the current
                  price, in anticipation that when that price is achieved, the
                  trend will continue lower.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Buy Limit</b>
                <span>
                  {" "}
                  An order to buy an asset at a lower price than the current
                  price, in anticipation that the asset price will turn higher
                  after having achieved a certain price.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Sell Limit `}</b>
                <span>
                  An order to sell an asset at a higher price than the current
                  price, in anticipation that the asset price will turn lower
                  after having achieved a certain price.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Buy Stop Limit</b>
                <span>
                  {" "}
                  A combination of buy stop and buy limit orders designed to
                  eliminate slippages. You set a buy stop limit at a price above
                  the current asset price, and when achieved, a buy limit order
                  will be placed.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Sell Stop Limit</b>
                <span>
                  {" "}
                  A combination of sell stop and sell limit orders designed to
                  eliminate slippages. You set a sell stop limit at a price
                  below the current price, and when achieved, a sell limit order
                  will be placed.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you apply Stop Loss and Take Profit orders, your trade
                positions will be automatically closed when they are triggered.
                You can also manually close the positions at any time before
                these orders are triggered.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Timeframes</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            So let’s start this MetaTrader 5 tutorial with the timeframes. Now,
            the timeframes is this bar you can see here on the taskbar.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            We have M1, M5, M15, M30, H1, H4, D1, W1, and MN. And basically what
            it is, is it’s the 1-minute chart, the 5-minute, the 15, the 30, the
            1 hour, the 4 hours, the 1 day, the 1 week, and the 1 month.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[34.94rem] object-cover"
          alt=""
          src="/i111@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>The Spread</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Now, if you right-click anywhere, you get the menu, and then we’re
            going to select Columns. And then for the purpose of this MetaTrader
            5 beginners tutorial what we will do from Columns is to select the
            Spread.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[36.06rem] object-cover"
          alt=""
          src="/i112@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Navigator</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Below the Market Watch, we have our navigator window.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[34.19rem] object-cover"
          alt=""
          src="/i113@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">The navigator window</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            And what you’ll see in the Navigator window is that we have our
            account information, the various indicators that are available to
            us. So if you had to put a custom indicator, it would appear here.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Next, we have the Expert Advisors and we will, of course, get into
            that a little bit more detail in another lecture, where I will show
            you a tutorial on how to put the Expert Advisors into MetaTrader 5
            and how to then attach them to your chart. And then below that, we
            have scripts and services and that’s about it.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Assets</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            One more thing I wanted to show you in this MetaTrader 5 tutorial,
            actually, guys, is that if you right-click anywhere on Market Watch,
            what you’ll see is that this menu pops up and we can then select
            Symbols.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[36.38rem] object-cover"
          alt=""
          src="/i114@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">Select Symbols</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            And now under Symbols, these are the various symbols that are
            available to us.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[26.56rem] object-cover"
          alt=""
          src="/i115@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">The various symbols available to us</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            As you can see, we have Forex, Commodities, Index, and Stocks. And
            under Stocks, we have a few sub-items. In the US, this is what we’ll
            be using.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            {`So we’ve got the Dow, the New York Stock Exchange, and the Nasdaq. There is the Crypto, which gives you the various cryptocurrencies that you can trade using MetaTrader 5 platform with this particular `}
            <a
              className="text-[inherit]"
              href="https://eatradingacademy.com/stock-trading-broker/"
              target="_blank"
            >
              <span className="[text-decoration:underline]">broker</span>
            </a>
            . And then Custom, nothing in Custom at the moment. If you want to
            add one, it’s very easy. Let’s go to Stocks. I go to the Dow, for
            example. Let’s say that we wanted to add Chevron. All we do is
            double-click it.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            And what you’ll see is that the icon has gone gold. And what you’ll
            see is on the left in the Market Watch window, CVX, there it is now
            available for us.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[31.13rem] object-cover"
          alt=""
          src="/i116@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Chart Window</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The next important thing to cover in this MetaTrader 5 tutorial
                for beginners is, of course, the main chart window.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Now, the chart I show you below is an AAPL, it’s an Apple chart.
                However, I do have 4 other charts open, so I have 5 charts. Each
                one is for a different asset. And if I want to see them all on
                the screen at the same time, I would simply go to Arrange
                windows button at the top, click on that and you’ll see MT5 will
                auto-arrange them.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[37.25rem] object-cover"
          alt=""
          src="/i117@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">Click on Arrange windows</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            {`If you double-click on the actual tab, so let’s say, for example, the `}
            <a
              className="text-[inherit]"
              href="https://eatradingacademy.com/tesla-stock-trading-strategy/"
              target="_blank"
            >
              <span className="[text-decoration:underline]">Tesla</span>
            </a>
            , if I double-click on that, it opens up Tesla and if I double-click
            on it again, it’ll go back to the auto arranged view.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[35.88rem] object-cover"
          alt=""
          src="/i118@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          Double-click on the tab
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Drawing Tools</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The next thing we have is the drawing tools. As Algo traders, we
                don’t use these because the Expert Advisors do all of the work
                for us.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[26.63rem] object-cover"
          alt=""
          src="/i119@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">The drawing tools</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            But just so you get an idea of what they are, let’s say, for
            example, we have the vertical tool. So let’s say there was a point
            on the chart that I wanted to mark, let’s say, for example, where we
            have quite a big bull candle. So we’re going to click on that. You
            can see it’s not quite there. So what we’re going to do, because
            these little squares are at the top and the bottom, we are able to
            move it and edit it.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            So what we’re going to do is just put our mouse on it and just drag
            it to where we want it.
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="https://unityacademy.io/dashboard">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center max-md:pb-[1.3rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson23;
